import { gql } from '@apollo/client';

export const GET_UPLOADS_BY_DATE_RANGE = gql`
  query CARRIER_FILE_SERVICE_getUploadsByDateRange($from: String!, $to: String!, $sponsorId: String) {
    getUploadsByDateRange(from: $from, to: $to, sponsorId: $sponsorId) {
      id
      domainId
      uploadDate
      uploadDateTime
      step
      fileType
      fileName
      processingOutput {
        validItemsFilePath
        invalidItemsFilePath
        processedItemsFilePath
        unprocessedItemsFilePath
      }
    }
  }
`;

export const GET_UPLOAD_URLS = gql`
  query CARRIER_FILE_SERVICE_getUploadUrls($files: [FileUpload!]!, $sponsorId: String) {
    getUploadUrls(files: $files, sponsorId: $sponsorId)
  }
`;

export const GET_OUTPUT_DOWNLOAD_URL = gql`
  query CARRIER_FILE_SERVICE_getOutputDownloadUrl($uploadId: String!, $fileName: String!) {
    getOutputDownloadUrl(uploadId: $uploadId, fileName: $fileName)
  }
`;

export const GET_UPLOAD_EXHIBIT_URLS = gql`
  query CARRIER_FILE_SERVICE_getUploadExhibitUrls($files: [String]!, $sponsorId: String!, $effectiveDate: String!) {
    getUploadExhibitUrls(files: $files, sponsorId: $sponsorId, effectiveDate: $effectiveDate)
  }
`;

export const GET_UPLOAD_EXHIBIT_ZIP_URL = gql`
  query CARRIER_FILE_SERVICE_getUploadExhibitZipUrl($urls: [String!]!) {
    getUploadExhibitZipUrl(urls: $urls)
  }
`;

export const DELETE_UPLOAD = gql`
  mutation CARRIER_FILE_SERVICE_deleteUpload($uploadId: String!) {
    deleteUpload(uploadId: $uploadId) {
      id
    }
  }
`;

export const VALIDATE_UPLOAD = gql`
  mutation CARRIER_FILE_SERVICE_validateUpload($uploadId: String!) {
    validateUpload(uploadId: $uploadId) {
      id
    }
  }
`;

export const PROCESS_UPLOAD = gql`
  mutation CARRIER_FILE_SERVICE_processUpload($uploadId: String!) {
    processUpload(uploadId: $uploadId) {
      id
    }
  }
`;
